import { Switch, SwitchOnChangeData, type SwitchProps } from "@fluentui/react-components";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { helpAnchor } from "help/anchor";
import { showExpiredPackagesAtom } from "store/UIBenefitsPage";

export function ShowExpiredPackagesSwitch() {
  const { t } = useTranslation();

  const [showExpired, setShowExpired] = useAtom(showExpiredPackagesAtom);
  return (
    <Switch
      // On the root, not the Switch: Fluent puts native props on the hidden <input>. Cast because
      // the root slot's type admits no data-* key.
      root={{ "data-help": helpAnchor("benefits-show-expired") } as SwitchProps["root"]}
      defaultChecked={showExpired}
      onChange={(_, data: SwitchOnChangeData) => {
        setShowExpired(!!data.checked);
      }}
      label={t("hbh.showExpired.label")}
      indicator={{
        style: {
          marginLeft: 0,
        },
      }}
      labelPosition="after"
    />
  );
}
